/**
 * GoNOW API
 * No description provided (generated by Swagger Codegen https://github.com/swagger-api/swagger-codegen)
 *
 * OpenAPI spec version: 2020-12-7
 * Contact: info@zero-spec.com
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 *
 */

import ApiClient from '../ApiClient';

/**
* The CreateSensorRequest model module.
* @module model/CreateSensorRequest
* @version 2020-12-7
*/
export default class CreateSensorRequest {
    /**
    * Constructs a new <code>CreateSensorRequest</code>.
    * センサー登録リクエスト
    * @alias module:model/CreateSensorRequest
    * @class
    * @param companyId {Number} アサイン先
    * @param sensorId {String} センサーID
    * @param serialNo {String} シリアルNo
    */

    constructor(companyId, sensorId, serialNo) {
        
        
        this['companyId'] = companyId;
        this['sensorId'] = sensorId;
        this['serialNo'] = serialNo;
        
    }

    /**
    * Constructs a <code>CreateSensorRequest</code> from a plain JavaScript object, optionally creating a new instance.
    * Copies all relevant properties from <code>data</code> to <code>obj</code> if supplied or a new instance if not.
    * @param {Object} data The plain JavaScript object bearing properties of interest.
    * @param {module:model/CreateSensorRequest} obj Optional instance to populate.
    * @return {module:model/CreateSensorRequest} The populated <code>CreateSensorRequest</code> instance.
    */
    static constructFromObject(data, obj) {
        if (data) {
            obj = obj || new CreateSensorRequest();
                        
            
            if (data.hasOwnProperty('companyId')) {
                obj['companyId'] = ApiClient.convertToType(data['companyId'], 'Number');
            }
            if (data.hasOwnProperty('sensorId')) {
                obj['sensorId'] = ApiClient.convertToType(data['sensorId'], 'String');
            }
            if (data.hasOwnProperty('serialNo')) {
                obj['serialNo'] = ApiClient.convertToType(data['serialNo'], 'String');
            }
        }
        return obj;
    }

    /**
    * アサイン先
    * @member {Number} companyId
    */
    'companyId' = undefined;
    /**
    * センサーID
    * @member {String} sensorId
    */
    'sensorId' = undefined;
    /**
    * シリアルNo
    * @member {String} serialNo
    */
    'serialNo' = undefined;




}
